const SupplementaryMaterial = {
  TodoSelectionTitle: "SupplementaryMaterial.TodoSelectionTitle",
  TodoSubmitSuccess: "SupplementaryMaterial.TodoSubmitSuccess",
  CommentHeader: "SupplementaryMaterial.CommentHeader",
  CommentSubHeader: "SupplementaryMaterial.CommentSubHeader",
  }
export default SupplementaryMaterial;